import { render, staticRenderFns } from "./GlobalSearchSingleResult.vue?vue&type=template&id=2b4e8092"
import script from "./GlobalSearchSingleResult.vue?vue&type=script&lang=js"
export * from "./GlobalSearchSingleResult.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports